export function formatPaymentAmount(amountMinor, currency = 'usd') {
  if (amountMinor === null || amountMinor === undefined || amountMinor === '') {
    return null;
  }

  const numericAmount = Number(amountMinor);
  if (!Number.isFinite(numericAmount) || numericAmount < 0) {
    return null;
  }

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: String(currency || 'usd').toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(numericAmount / 100);
  } catch (error) {
    return `$${(numericAmount / 100).toFixed(numericAmount % 100 === 0 ? 0 : 2)}`;
  }
}

export function buildPaymentRecoveryMessage(subscription = {}, graceDate = null) {
  const amount = formatPaymentAmount(
    subscription.paymentFailedAmountDue,
    subscription.paymentFailedCurrency
  );
  const pastDueMessage = amount
    ? `Your ${amount} payment is past due.`
    : 'Your payment is past due.';
  const deadline = graceDate ? ` by ${graceDate},` : '';

  return `${pastDueMessage} Please update your card${deadline} to keep dashboard access active.`;
}
